import { PatchVideoOptions, PatchVideoFields } from '@vimeo/gctl-api/fetchers/video';
import { usePatchVideo } from '@vimeo/gctl-api/hooks/useVideo';

import { getPasswordHashFromCookie } from './utils';

type UsePatchVideoOptions<Fields extends PatchVideoFields> = PatchVideoOptions<Fields>;

/**
 * usePatchUnlockedVideo - Utility hook that wraps around GCTL `usePatchVideo` and allows us to send password hash as a parameter for password-protected videos
 */
export function usePatchUnlockedVideo<Fields extends PatchVideoFields>() {
  const [call, state] = usePatchVideo();

  const _call = async (options: UsePatchVideoOptions<Fields>): Promise<void> => {
    const password = getPasswordHashFromCookie(options?.where.videoId);

    const opts: UsePatchVideoOptions<Fields> = {
      ...options,
      // @ts-expect-error Permit passing options with password cookie
      query: {
        ...(password && { password }),
      },
    };

    return call(opts);
  };

  return [_call, state] as const;
}
